__turbopack_context__.v({
  "containsCta": "P-P2Aq_containsCta",
  "ctaContainer": "P-P2Aq_ctaContainer",
  "panelSubtitle": "P-P2Aq_panelSubtitle",
  "panelTitle": "P-P2Aq_panelTitle",
  "panelTitles": "P-P2Aq_panelTitles",
  "url": "P-P2Aq_url",
});
